<mat-expansion-panel [expanded]="initialExpanded" (opened)="toggleExpanded()" (closed)="toggleExpanded()">
    <mat-expansion-panel-header>
        <mat-panel-title>SURVEY RESPONSES
            <mat-icon class="m-l-10 m-b-5 full-width" *ngIf="!stateMode"
                matTooltip="You can enable automatic survey requests by appointment type in Settings > Survey Template">
                info
            </mat-icon>
        </mat-panel-title>
        <mat-panel-description>
            <button mat-button *ngIf="!stateMode" (click)="sendManualSurvey($event)" [disabled]="!patient || !selectedGroup"
                matTooltip="Send satisfaction survey manually">
                <mat-icon>send</mat-icon>
                Send Survey
            </button>
        </mat-panel-description>
    </mat-expansion-panel-header>
    <div class="survey-responses-info">
        <ng-container *ngIf="groupedSurveyData; else listLoading">
            <ng-container *ngIf="groupedSurveyData.length; else noResults">
                <ng-container *ngFor="let dateGroup of groupedSurveyData">
                    <div class="list-header">
                        {{ dateGroup.dateDisplay }}
                    </div>
                    <mat-list class="full-width">
                        <ng-container *ngFor="let survey of dateGroup.surveys">
                            <mat-list-item class="auto-height normal-spacing">
                                <div class="survey-item">
                                    <div class="survey-details">
                                        <div matLine class="survey-title">
                                            <span>{{ survey.surveyTitle }}</span>
                                            <div class="survey-meta">
                                                <button mat-icon-button *ngIf="hasResponses(survey)"
                                                    matTooltip="Toggle Responses"
                                                    (click)="toggleSurveyResponses(survey)">
                                                    <mat-icon>{{ survey.showResponses ? 'expand_less' : 'expand_more'
                                                        }}</mat-icon>
                                                </button>
                                                <span class="survey-status" [ngClass]="getSurveyStatusClass(survey)">
                                                    {{ getSurveyStatus(survey) }}
                                                </span>
                                                <button mat-icon-button *ngIf="getSurveyStatus(survey) === 'Expired'"
                                                    matTooltip="Delete expired survey" (click)="deleteSurvey(survey)"
                                                    class="delete-survey-btn">
                                                    <mat-icon>delete</mat-icon>
                                                </button>
                                                <span class="survey-score" [ngClass]="'score-' + getSurveyScore(survey)"
                                                    *ngIf="survey.completed">
                                                    Score: {{ getSurveyScoreDisplay(survey) }}/5
                                                </span>
                                            </div>
                                        </div>

                                        <div matLine class="survey-footer">
                                            <div>Created: {{ formatDate(survey.createdAt) }}</div>
                                            <div *ngIf="survey.completedAt">Completed: {{ formatDate(survey.completedAt)
                                                }}</div>
                                            <div *ngIf="survey.PatientAppointment">
                                                Appointment: {{ formatDate(survey.PatientAppointment.date, false) }}
                                                {{ survey.PatientAppointment.timeSlot }}
                                            </div>
                                        </div>

                                        <!-- Survey Responses -->
                                        <ng-container *ngIf="hasResponses(survey) && survey.showResponses">
                                            <div class="survey-responses">
                                                <ng-container *ngFor="let section of getSections(survey)">
                                                    <div class="survey-section"
                                                        *ngIf="hasSectionResponses(survey, section.id)">
                                                        <h4>{{ section.title }}</h4>
                                                        <ng-container *ngFor="let question of section.questions">
                                                            <div class="survey-question"
                                                                *ngIf="survey.responses[question.id]">
                                                                <strong>{{ question.question }}</strong>
                                                                <ng-container *ngIf="question.type === 'radio'">
                                                                    - {{ getOptionText(survey, question.id,
                                                                    survey.responses[question.id]) }}
                                                                </ng-container>
                                                                <ng-container *ngIf="question.type === 'textarea'">
                                                                    <div class="textarea-response">{{
                                                                        survey.responses[question.id] }}</div>
                                                                </ng-container>
                                                            </div>
                                                        </ng-container>
                                                    </div>
                                                </ng-container>
                                            </div>
                                        </ng-container>

                                        <div class="list-actions icons"
                                            *ngIf="hasResponses(survey) && survey.showResponses">
                                            <button mat-icon-button matTooltip="Copy survey data to clipboard"
                                                (click)="copySurveyData(survey)">
                                                <mat-icon>copy_all</mat-icon>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </mat-list-item>
                        </ng-container>
                    </mat-list>
                </ng-container>
            </ng-container>
        </ng-container>
    </div>
</mat-expansion-panel>

<ng-template #listLoading>
    <div class="list-loading">
        <mat-spinner color="primary" mode="indeterminate" diameter="20" style="float:right;"></mat-spinner>
    </div>
</ng-template>

<ng-template #noResults>
    <p class="no-records-message">No survey responses found.</p>
</ng-template>